import React from "react";
import { DisplayText, TextStyle } from "@shopify/polaris";
import step1 from "../../assets/welcome_0.png"

const Step1 = () => {
  return (
    <div className="tab-pane">
      <div className="panel-heading pb-4 text-center">
        <DisplayText size="medium">
          Welcome to SyncTrack - Add Tracking Auto
        </DisplayText>
      </div>
      <div className="panel-body">
        <div className="text-center">
          <img
            style={{ width: "80%" }}
            src={step1}
            alt="Responsive image"
          />
          <DisplayText size="medium">Ready to Build PayPal Trust? </DisplayText>
          <p className="text-center mt-4" style={{ fontSize: "16px" }}>
            <TextStyle variation="subdued">
              Let's do some few steps to configure your account, so SyncTrack
              can work properly. 
            </TextStyle>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Step1;
